import { render } from "./SearchSelect.vue?vue&type=template&id=5edd028f"
import script from "./SearchSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchSelect.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/SearchSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5edd028f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5edd028f', __exports__)) {
    api.reload('5edd028f', __exports__)
  }
  
  module.hot.accept("./SearchSelect.vue?vue&type=template&id=5edd028f", () => {
    api.rerender('5edd028f', render)
  })

}


export default __exports__